// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-main__wrap[data-v-513b4ffc],.v-main__wrap .container[data-v-513b4ffc]{display:flex}", ""]);
// Exports
module.exports = exports;
